import { render, staticRenderFns } from "./DesignView.vue?vue&type=template&id=8fb72078&scoped=true"
import script from "./DesignView.vue?vue&type=script&lang=js"
export * from "./DesignView.vue?vue&type=script&lang=js"
import style0 from "./DesignView.vue?vue&type=style&index=0&id=8fb72078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb72078",
  null
  
)

export default component.exports